import { Task } from '../types';
import { BarzhaResponse, BarzhaStatusTask } from './sponsors/types/barzha';
import { BarzhaAdapter } from './sponsors/BarzhaAdapter';
import { SponsorsAdapter } from './sponsors/SponsorAdapter';
import { FlyerAdapter } from './sponsors/FlyerAdapter';
import { SponsorsTask } from './sponsors/types/sponsors';

interface SponsorsResponse {
  status: string;
  tasks: SponsorsTask[];
}

export enum SponsorType {
  BARZHA = 'barzha',
  BANNER_CPM = 'banner_cpm',
  BANNER_CPC = 'banner_cpc',
  BARZHA_CLICK = 'barzha_click',
  FLYER = 'flyer',
  TRAFFY = 'traffy',
  SPONSORS = 'sponsors',
  SPONSOR_CLICK = 'sponsor-click',
  SPONSOR_SUBS = 'sponsor-subs',
}

export class SponsorsTasksAdapter {
  static async adaptTasks(
    sponsorType: SponsorType,
    response: BarzhaResponse | SponsorsResponse | any[],
    statusTasks?: BarzhaStatusTask[],
  ): Promise<Task[]> {
    console.log('🔄 SponsorsTasksAdapter.adaptTasks - start', {
      sponsorType,
      response,
      statusTasks,
    });

    switch (sponsorType) {
      case SponsorType.BARZHA:
        return BarzhaAdapter.adaptTasks(
          response as BarzhaResponse,
          statusTasks as BarzhaStatusTask[],
        );

      case SponsorType.FLYER:
        console.log('🔄 Processing FLYER tasks');
        console.log('📦 Response structure:', response);
        console.log('🔍 Has tasks property:', 'tasks' in response);

        if ('tasks' in response) {
          console.log('📋 Tasks array:', response.tasks);
          const adaptedTasks = FlyerAdapter.adaptTasks(response.tasks as any[]);
          console.log('✅ FLYER tasks adapted:', adaptedTasks);
          return adaptedTasks;
        }
        console.warn(
          '❌ Flyer response does not contain tasks array:',
          response,
        );
        return [];

      case SponsorType.SPONSORS:
        if ('tasks' in response) {
          return SponsorsAdapter.adaptTasks(response as SponsorsResponse);
        }
        console.warn(
          '❌ Sponsors response does not contain tasks array:',
          response,
        );
        return [];

      default:
        console.warn(`Unknown sponsor type: ${sponsorType}`);
        return [];
    }
  }
}
